/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_ActionInputs */

const en_invoice_request_action = /** @type {(inputs: Invoice_Request_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request an invoice`)
};

const pl_invoice_request_action = /** @type {(inputs: Invoice_Request_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poproś o fakturę`)
};

/**
* | output |
* | --- |
* | "Request an invoice" |
*
* @param {Invoice_Request_ActionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_action = /** @type {((inputs?: Invoice_Request_ActionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_ActionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_action(inputs)
	return en_invoice_request_action(inputs)
});